import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Form } from 'antd';
import DspxModal from '../../../common/DspxModal/DspxModal';
import HouseInfoForm from '../../forms/HouseInfoForm/HouseInfoForm';
import { houseInfoFieldsNames } from '../../forms/HouseInfoForm/constants/houseInfoFieldsNames';

const { constructionYear, commissioningYear, type } = houseInfoFieldsNames;

const HouseInfoModalNode = ({
  form,
  onCancel,
  address,
  houseId,
  initialValues,
  ...props
}) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const queryClient = useQueryClient();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleCancel = () => {
    resetFields();
    onCancel();
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldsValues) => {
      if (!err) {
        setConfirmLoading(true);
        const values = {
          ...fieldsValues,
          [type]: {
            id: fieldsValues[type].key,
            name: fieldsValues[type].label,
          },
          [constructionYear]: fieldsValues[constructionYear].format('YYYY'),
          [commissioningYear]: fieldsValues[commissioningYear].format('YYYY'),
        };
        console.log('values', values);
        // queryClient.invalidateQueries([`houseInfo`, houseId]);
        setConfirmLoading(false);
        handleCancel();
      }
    });
  };

  return (
    <DspxModal
      wrapClassName="houseInfoModal"
      title="Общая информация по дому"
      okText="Сохранить"
      cancelText="Отменить"
      onOk={handleSubmit}
      onCancel={handleCancel}
      cancelButtonProps={{
        disabled: confirmLoading,
      }}
      confirmLoading={confirmLoading}
      {...props}
    >
      <HouseInfoForm
        form={form}
        address={address}
        initialValues={initialValues}
      />
    </DspxModal>
  );
};

const HouseInfoModal = Form.create({ name: 'add_house_info' })(
  HouseInfoModalNode
);

export default HouseInfoModal;
